import axios from "axios";

export default {
  namespaced: true,
  state: {
    settings: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    systemsettingsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = state.isReceiving==true ? true : false;
    },
    RECEIVED_SYSTEMSETTINGS(state, payload) {
      state.settings = payload;
      state.isReceiving = false;
    },
    RECEIVING_SYSTEMSETTINGS(state) {
      state.isReceiving = true;
    },
    STOP_SYSTEMSETTINGS(state) {
      state.isReceiving = false;
    },
    RECEIVED_SYSTEMSETTING(state, payload) {
      console.log("RECEIVED SYSTEMSETTING", payload);
      state = Object.assign(state, {
        settings: [...state.settings, payload],
        isReceiving: false,
      })
    },
    RECEIVING_SYSTEMSETTING(state) {
      state.isReceiving = true;
    },
    UPDATED_SYSTEMSETTING(state, payload) {
      console.log(state.settings);
      console.log(payload);
      let index = state.settings.findIndex(systemsetting => systemsetting._id === payload._id);
      state = Object.assign(state, {
        settings: state.settings.map((systemsetting, i) => {
          if (i === index) {
            return Object.assign({}, systemsetting, payload);
          }
          return systemsetting;
        }),
        isUpdating: false,
        systemsettingsMessage: 'SystemSettings has been updating!',
      })
    },
    UPDATING_SYSTEMSETTING(state) {
      state.isUpdating = true;
    },
    DELETED_SYSTEMSETTING(state, payload) {
      console.log("DELETE", payload);
      let indexToDelete = state.settings.findIndex(systemsetting => systemsetting._id === payload._id);
      console.log(indexToDelete);
      let settings = [...state.settings];
      settings.splice(indexToDelete, 1);
      state = Object.assign(state, {
        settings: [...settings],
        isDeleting: false,
        idToDelete: null,
        systemsettingsMessage: 'SystemSetting has been Deleted!',
      });
    },
    DELETING_SYSTEMSETTING(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteSystemSettingRequest({dispatch}, payload) {
      dispatch("deletingSystemSetting", payload);
      var token = localStorage.getItem('token')
      var url = 'https://api.accountxc.com:3100/delete/systemsetting/' + payload._id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var del = {
        method: "delete",
        url: url,
        headers: header,
      };

      axios(del)
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteSystemSetting", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deleteSystemSettingListRequest({dispatch}, payload) {
      try{
        dispatch("deletingSystemSetting", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/systemsettinglist/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteSystemSetting", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteSystemSettingImageRequest({dispatch}, payload) {
      try{
        dispatch("deletingSystemSetting", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/systemsettingimage/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteSystemSetting", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getSystemSettingsRequest({dispatch}) {
      dispatch("receivingSystemSettings");
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/get/systemsettings';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: headers});
      dispatch("receiveSystemSettings", response.data);
    },
    async getSetting({dispatch, state}, payload) {
      dispatch("doNothing");
      if(state.settings.length==0) await dispatch("getSystemSettingsRequest");
      let settings = Object.assign([], state.settings);
      let results = settings.find(setting=>setting.settingcode==payload.code);
      if(results==null) return null;

      let result = results.settinglists.find(result=>result.settingname==payload.name);
      let value = result!=null ? result.settingvalue : '';
      if(value.trim()=='true') value=true;
      else if(value.trim()=='false') value=false;
      return value;
    },
    getCompanySetting({state}, name){
      let companysettings = state.settings.find(setting=>setting.settingcode=='CompanySettings'); 
      if(!companysettings) return null;
      let result = companysettings.settinglists.find(list=>list.settingname==name);
      if(result==null) return null;
      let value = result.settingvalue;
      value = value=='true' ? true : value;
      value = value=='false' ? false : value;
      value = value==null ? false : value;
      return value;
    },
    getCurrencySetting({state}, name){
      let currencysettings = state.settings.find(setting=>setting.settingcode=='CurrencySettings'); 
      if(!currencysettings) return null;
      let result = currencysettings.settinglists.find(list=>list.settingname==name);
      if(result==null) return null;
      let value = result.settingvalue;
      value = value=='true' ? true : value;
      value = value=='false' ? false : value;
      value = value==null ? false : value;
      return value;
    },
    getTaxSetting({state}, name){
      let taxsettings = state.settings.find(setting=>setting.settingcode=='TaxSettings');
      if(!taxsettings) return null;
      let result = taxsettings.settinglists.find(list=>list.settingname==name);
      if(result==null) return null;
      let value = result.settingvalue;
      value = value=='true' ? true : value;
      value = value=='false' ? false : value;
      value = value==null ? false : value;
      return value;
    },
    async getWeekendSetting({dispatch, state}) {
      dispatch("doNothing");
      if(state.settings.length==0) await dispatch("getSystemSettingsRequest");
      let settings = Object.assign([], state.settings);
      
      let results = settings.find(setting=>setting.settingcode=='WorkplaceSettings');
      let result1 = results.settinglists.find(result=>result.settingname=='isSaturdayHoliday');
      let result2 = results.settinglists.find(result=>result.settingname=='isSundayHoliday');

      let value1 = result1!=null ? result1.settingvalue : '';
      if(value1.trim()=='true') value1=true;
      else if(value1.trim()=='false') value1=false;
      let value2 = result2!=null ? result2.settingvalue : '';
      if(value2.trim()=='true') value2=true;
      else if(value2.trim()=='false') value2=false;

      return {isSaturdayHoliday: value1, isSundayHoliday: value2};
    },
    async insertSystemSettingListRequest({dispatch}, payload) {
      try{
        dispatch("receivingSystemSetting");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/systemsettinglist/' + payload.systemsettingid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertSystemSettingImageRequest({dispatch}, payload) {
      let url;
      let data;
      console.log(payload)
      try{
        dispatch("receivingSystemSetting");
        if(payload.imagefile!=null){
          url = 'https://api.accountxc.com:3100/insert/systemsettingimage/withimage/' + payload.systemsettingid;
          data = new FormData();
          data.append('file', payload.imagefile, payload.imagefilename); 
          delete payload['imagefile'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.accountxc.com:3100/insert/systemsettingimage/' + payload.systemsettingid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateSystemSettingRequest({dispatch}, payload) {
      dispatch("updatingSystemSetting");
      var id = payload._id;
      delete payload['_id'];
      console.log(id, payload);


      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/systemsetting/' + id;
      var header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };
      var put = {
        method: "put",
        url: url,
        headers: header,
        data: payload,
      };

      axios(put)
      .then(function (res) {
        console.log(res);
        dispatch("updateSystemSetting", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateSystemSettingImageRequest({dispatch}, payload) {
      let url;
      let data;
      console.log(payload);
      try{
        dispatch("updatingSystemSetting");
        if(payload.imagefile!=null){
          url = 'https://api.accountxc.com:3100/update/systemsettingimage/withimage/' + payload.systemsettingimageid;
          data = new FormData();
          data.append('file', payload.imagefile, payload.imagefilename); 
          delete payload['imagefile'];
          for (let x in payload) {
            data.append(x, payload[x]);
          }
        }
        else{
          data = payload;
          url = 'https://api.accountxc.com:3100/update/systemsettingimage/' + payload.systemsettingimageid;
        }
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log(url)
        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("updateSystemSetting", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    createSystemSettingRequest({dispatch}, payload) {
      console.log(payload);
      dispatch("receivingSystemSettings");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');
      url = 'https://api.accountxc.com:3100/insert/systemsetting';
      data = payload;
      header = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then((response)=> {
        console.log(response.data);
        dispatch("receiveSystemSetting", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    async updateSystemSettingListRequest({dispatch}, payload) {
      try{
        dispatch("receivingSystemSetting");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/systemsettinglist/' + payload.systemsettinglistid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveSystemSetting", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveSystemSettings({commit}, payload) {
      commit("RECEIVED_SYSTEMSETTINGS", payload)
    },
    receivingSystemSettings({commit}) {
      commit("RECEIVING_SYSTEMSETTINGS")
    },
    stopSystemSettings({commit}) {
      commit("STOP_SYSTEMSETTINGS")
    },
    receiveSystemSetting({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_SYSTEMSETTING", payload)
    },
    receivingSystemSetting({commit}) {
      commit("RECEIVING_SYSTEMSETTING")
    },
    updateSystemSetting({commit}, payload) {
      commit("UPDATED_SYSTEMSETTING", payload)
    },
    updatingSystemSetting({commit}) {
      commit("UPDATING_SYSTEMSETTING")
    },
    deleteSystemSetting({commit}, payload) {
      console.log(payload);
      commit("DELETED_SYSTEMSETTING", payload)
    },
    deletingSystemSetting({commit}, payload) {
      commit("DELETING_SYSTEMSETTING", payload)
    }
  },
};
